const WA_ICON_SM = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:16px;height:16px;fill:currentColor;flex-shrink:0;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;

function buildWaUrl(siteData) {
  const wa = siteData?.whatsapp;
  if (!wa || !wa.enabled) return null;
  const msg = encodeURIComponent(wa.default_message || "Hi Antiopix! I'd like to discuss a project.");
  return `https://wa.me/${wa.number}?text=${msg}`;
}

export function getContactFormHTML(siteData = null, idPrefix = 'contact', isModal = false) {
  const num1 = Math.floor(Math.random() * 10) + 1;
  const num2 = Math.floor(Math.random() * 10) + 1;

  const waUrl = buildWaUrl(siteData);
  const waBlock = waUrl ? `
    <div class="whatsapp-contact-block">
      <div style="display:flex;flex-direction:column;gap:0.25rem;flex:1;">
        <p style="font-weight:600;color:var(--text-primary);font-size:0.9rem;margin:0;">Prefer a quick chat?</p>
        <p>Message us directly on WhatsApp — we typically respond in under an hour.</p>
      </div>
      <a href="${waUrl}" onclick="window.open(this.href, 'whatsapp', 'width=600,height=700'); return false;" class="btn btn-whatsapp" style="padding:0.65rem 1.25rem;font-size:0.85rem;white-space:nowrap;">
        ${WA_ICON_SM} Chat Now
      </a>
    </div>
  ` : '';

  const headerHTML = isModal ? '' : `
    <div class="animate-on-scroll" style="text-align:center;margin-bottom:3rem;">
      <span class="section-eyebrow">Get In Touch</span>
      <h2 class="text-hero-display" style="font-size:clamp(2rem,4vw,3.25rem);margin-bottom:1rem;">Let's Build Something Great</h2>
      <p style="font-size:1.1rem;color:var(--text-secondary);max-width:500px;margin:0 auto;">
        Drop us a message and we'll get back to you within one business day.
      </p>
    </div>
  `;

  return `
    ${headerHTML}
    <div class="animate-on-scroll glass-card" style="max-width:620px; width:100%; margin:0 auto; background: var(--bg-elevated); border-color: rgba(255,255,255,0.1);">
      <form id="${idPrefix}-form" data-expected="${num1 + num2}" style="display:flex; flex-direction:column; gap:1.25rem;">
        <div style="display:grid; grid-template-columns:1fr 1fr 1fr; gap:1.25rem;">
          <input type="text" name="name" placeholder="Your Name" class="form-input" required style="background: var(--bg-surface);">
          <input type="email" name="email" placeholder="Your Email" class="form-input" required style="background: var(--bg-surface);">
          <input type="tel" name="mobile" placeholder="Mobile Number" class="form-input" required style="background: var(--bg-surface);">
        </div>
        <textarea name="message" placeholder="Tell us about your project..." rows="5" class="form-input" required style="background: var(--bg-surface);"></textarea>
        <div style="display:flex; flex-direction:column; gap:0.5rem; text-align:left;">
          <label style="font-size:0.85rem; color:var(--text-secondary);">Quick check: What is ${num1} + ${num2}?</label>
          <input type="number" id="${idPrefix}-captcha" placeholder="Your answer" class="form-input" required style="max-width:180px; background: var(--bg-surface);">
        </div>
        <button type="submit" class="btn btn-primary glow-button" id="${idPrefix}-submit-btn" style="margin-top:0.5rem;">
          Send Message →
        </button>
      </form>
      <div id="${idPrefix}-result" style="margin-top:1.25rem; text-align:center; font-weight:500;"></div>
      ${waBlock}
    </div>
  `;
}

export function bindContactFormEvents(idPrefix = 'contact') {
  const form = document.getElementById(`${idPrefix}-form`);
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const resultDiv = document.getElementById(`${idPrefix}-result`);
    const submitBtn = document.getElementById(`${idPrefix}-submit-btn`);

    const expectedAnswer = parseInt(form.getAttribute('data-expected'), 10);
    const userAnswer = parseInt(document.getElementById(`${idPrefix}-captcha`).value, 10);
    if (userAnswer !== expectedAnswer) {
      resultDiv.textContent = 'Incorrect security check answer. Please try again.';
      resultDiv.style.color = '#ef4444';
      return;
    }

    resultDiv.style.color = 'var(--text-secondary)';
    resultDiv.textContent = 'Sending…';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

    try {
      const formData = new FormData(e.target);
      const dataPayload = Object.fromEntries(formData.entries());
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataPayload)
      });
      const data = await response.json();
      if (data.success) {
        resultDiv.textContent = '✓ Message sent! We\'ll be in touch soon.';
        resultDiv.style.color = '#10b981';
        e.target.reset();
      } else {
        resultDiv.textContent = 'Failed to send message. Please try again.';
        resultDiv.style.color = '#ef4444';
      }
    } catch {
      resultDiv.textContent = 'Error sending message. Please try again.';
      resultDiv.style.color = '#ef4444';
    } finally {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send Message →'; }
    }
  });
}

export async function renderPage(siteData = null) {
  const content = document.getElementById('page-content');
  content.innerHTML = `
    <section class="hero" style="min-height:80vh; display:flex; align-items:center; justify-content:center; padding: 0 5%;">
      ${getContactFormHTML(siteData)}
    </section>
  `;
  bindContactFormEvents();

  // Inject floating WhatsApp FAB if configured
  if (siteData?.whatsapp?.enabled && siteData?.whatsapp?.show_fab) {
    const fabContainer = document.getElementById('whatsapp-fab-container');
    const waUrl = buildWaUrl(siteData);
    if (fabContainer && waUrl) {
      fabContainer.innerHTML = `
        <a href="${waUrl}" onclick="window.open(this.href, 'whatsapp', 'width=600,height=700'); return false;" class="whatsapp-fab" aria-label="Chat on WhatsApp">
          ${WA_ICON_SM}
          <span class="whatsapp-fab-tooltip">Chat with us!</span>
        </a>
      `;
    }
  }
}
